import React from 'react';
import {
  ButtonSectionWrapper,
  VerticalSeparatorDiv,
} from '../DataModelerCommonUI';
import { TextButton } from '../../../../components/Button';

interface IProps {
  isEditMode: boolean;
  numTables: number;
  onAddTableClick: () => void;
}

const AddTableSubHeader = ({
  isEditMode,
  numTables,
  onAddTableClick,
}: IProps) => {
  return (
    <ButtonSectionWrapper>
      <div>
        {numTables} Table{numTables === 1 ? '' : 's'}
      </div>
      {isEditMode && (
        <>
          <VerticalSeparatorDiv layout="vertical" size="short" />
          <TextButton onClick={onAddTableClick}>+ Add Table</TextButton>
        </>
      )}
    </ButtonSectionWrapper>
  );
};

export default AddTableSubHeader;
